<script setup lang="ts"></script>

<template>
   <section class="backdrop-warning">
      <AnimLoadingScreen class="h-20 text-primary-30" />
   </section>
</template>
